export default __webpack_public_path__ + "static/media/FRASES_13.e727b180.png";